import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../utils/cn';

interface FeatureCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  delay?: number;
  bgColor?: string; // 👈 NEW prop for background color
}

const FeatureCard: React.FC<FeatureCardProps> = ({
  icon,
  title,
  description,
  delay = 0,
  bgColor = 'bg-white', // default value
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{
        opacity: 1,
        y: 0,
        transition: {
          duration: 0.5,
          delay,
          ease: [0.22, 1, 0.36, 1],
        },
      }}
      whileHover={{
        scale: 1.05,
        transition: { duration: 0.2 },
      }}
      viewport={{ once: true }}
      className={cn(
        bgColor, // 👈 Apply background color
        'rounded-xl p-8',
        'shadow-lg border border-gray-100 dark:border-gray-700',
        'hover:shadow-xl transition-all duration-300',
        'hover:border-lime-600 dark:hover:border-lime-500',
        'group cursor-pointer'
      )}
    >
      <div className="relative">
        <div className="h-12 w-12 rounded-lg bg-lime-100 dark:bg-lime-900/30 flex items-center justify-center text-lime-700 dark:text-lime-400 mb-6 group-hover:scale-110 transition-transform duration-300">
          {icon}
        </div>
        <motion.div
          initial={{ width: 0 }}
          whileInView={{
            width: '100%',
            transition: {
              duration: 0.8,
              delay: delay + 0.3,
              ease: [0.22, 1, 0.36, 1],
            },
          }}
          viewport={{ once: true }}
          className="absolute -bottom-2 left-0 h-0.5 bg-lime-500/20"
        />
      </div>
      <h3 className="text-xl font-semibold text-black dark:text-white mb-4 group-hover:text-lime-700 dark:group-hover:text-lime-400 transition-colors">
        {title}
      </h3>
      <p className="text-gray-700 dark:text-gray-300">{description}</p>
    </motion.div>
  );
};

export default FeatureCard;
